import { SxProps, Theme } from "@mui/material/styles";

export const styles = {
  container: (backgroundImage: string): SxProps<Theme> => ({
    display: "flex",
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center 25%",
    backgroundRepeat: "no-repeat",
  }),

  logoContainer: (isMobile: boolean): SxProps<Theme> => ({
    position: "absolute",
    top: "25px",
    left: "25px",
    display: "flex",
    alignItems: "center",
  }),

  logo: (isMobile: boolean): SxProps<Theme> => ({
    height: isMobile ? "100px" : "150px",
    width: "auto",
  }),

  formContainer: (isMobile: boolean): SxProps<Theme> => ({
    width: "100%",
    maxWidth: isMobile ? "75%" : "460px",
    display: "flex",
    flexDirection: "column",
    marginTop: "80px",
    gap: 2,
    backgroundColor: "#fff",
    px: isMobile ? "24px" : "40px",
    py: isMobile ? "28px" : "36px",
    borderRadius: 2,
    boxShadow: 3,
    "@media (max-width: 390px)": {
      maxWidth: 250,
    },
  }),

  heading: (isMobile: boolean): SxProps<Theme> => ({
    fontSize: isMobile ? "20px" : "45px",
    textAlign: "left",
    marginBottom: 2,
  }),

  label: (isMobile: boolean): SxProps<Theme> => ({
    color: "#333",
    fontWeight: 400,
    fontSize: isMobile ? "10px" : "14px",
    marginBottom: 0.5,
  }),

  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "5px",
      backgroundColor: "rgba(250, 250, 250, 1)",
    },
  },

  iconButton: {
    color: "#000",
  },

  rememberMeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  checkbox: {
    "&.Mui-checked": {
      color: "#1565c0",
    },
  },
  rememberMeLabel: (isMobile: boolean) => ({
    fontSize: isMobile ? "10px" : "14px",
  }),

  forgotPassword: (isMobile: boolean) => ({
    color: "#000",
    fontSize: isMobile ? "10px" : "14px",
    textDecoration: "none",
    fontWeight: 500,
  }),

  loginButton: (isMobile: boolean) => ({
    backgroundColor: "#000",
    color: "#fff",
    borderRadius: "5px",
    padding: "10px 0",
    fontSize: isMobile ? "10px" : "16px",
    "&:hover": {
      backgroundColor: "#333",
    },
  }),
};
